// SPM Downloads plugin
// The semi-colon before the function invocation is a safety
// net against concatenated scripts and/or other plugins
// that are not closed properly.
; (function ($, window, document, undefined) {

    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'spmdownloads';
    var defaults = {};

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this.xhr = null;

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {
        var $base = this;
        
        $base.$element.on('change', 'select', function (e) {
            e.preventDefault();

            $base.getFiles();
            $base.setWindowLocation();
        });

        $base.$element.on('keypress', 'input[type="text"]', function (e) {
            
            var key = e.which || e.keyCode || 0;
            if (key === 13) {
                $base.getFiles();
                $base.setWindowLocation();
                e.preventDefault();
            }
        });

        $(document).on('click', '.add-to-downloads', function (e) {
            e.preventDefault();

            $base.addToMyDownloads($(this));
        });

        $($base.$element.data('mydownloadswrapper')).on('click', '.remove', function (e) {
            e.preventDefault();

            $base.removeFromMyDownloads($(this));
        });

        window.onpopstate = function (event) {
            //console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
            $base.initFilters();
        };

        $base.initFilters();
    };

    Plugin.prototype.initFilters = function () {
        var $base = this;

        var entries = Array.from(new URL(window.location.href).searchParams.entries());
        if (entries && entries.length > 0) {
            for (var i = 0; i < entries.length; i++) {

                var $input = $('#' + entries[i][0], $base.$element);
                if ($input && $input.length > 0) {
                    $input.val(entries[i][1]);
                }
            }
        }

        $base.getFiles();
    };

    Plugin.prototype.getRequestData = function () {
        var $base = this;

        return {
            FilterCategoryId: parseInt($('#category', $base.$element).val()),
            FilterTag: $('#tag', $base.$element).val(),
            ModifiedSinceId: parseInt($('#modifiedsince', $base.$element).val()),
            ModifiedSince: $('#modifiedsince option:selected', $base.$element).data('date'),
            FilterText: $('#text', $base.$element).val()
        };
    };

    Plugin.prototype.setWindowLocation = function () {
        var $base = this;

        var url = new URL(window.location.href);
        var request = $base.getRequestData();

        // Clear
        var keys = Array.from(url.searchParams.keys());
        for (var i = 0; i < keys.length; i++) {
            url.searchParams.delete(keys[i]);
        }
        
        if (!isNaN(request.FilterCategoryId)) {
            url.searchParams.set("category", request.FilterCategoryId);
        }

        if (request.FilterTag && request.FilterTag.length > 0) {
            url.searchParams.set("tag", request.FilterTag);
        }

        if (!isNaN(request.ModifiedSinceId)) {
            url.searchParams.set("modifiedsince", request.ModifiedSinceId);
        }

        if (request.FilterText && request.FilterText.length > 0) {
            url.searchParams.set("text", request.FilterText);
        }

        history.pushState("", document.title, url);
    };

    Plugin.prototype.getFiles = function () {
        var $base = this;
        
        var $fileswrapper = $($base.$element.data('fileswrapper'));
        
        $base.xhr = $.ajax({
            type: 'POST',
            data: $base.getRequestData(),
            url: '/partials/downloads/files',
            beforeSend: function () {
                if ($base.xhr !== null) {
                    $base.xhr.abort();
                }

                $fileswrapper.html('<div class="d-flex justify-content-center"><i class="fas fa-circle-notch fa-spin"></i></div>');
            },
            success: function (data) {
                $fileswrapper.html(data);
            }
        });
    };

    Plugin.prototype.addToMyDownloads = function ($sender) {
        var $base = this;

        var filepath = $sender.data('filepath');
        var filename = $sender.data('filename');
        var $mydownloads = $($base.$element.data('mydownloadswrapper'));

        if ($('li[data-filepath="' + filepath + '"]', $mydownloads).length > 0) {
            return;
        }

        $('<li class="list-group-item d-flex justify-content-between align-items-center" data-filepath="' + filepath + '"><a href="' + filepath + '" class="text-truncate" target="_blank">' + filename + '</a><a href="#" title="Remove file" class="remove"><i class="fas fa-times"></i></a></li>').appendTo($('ul', $mydownloads));

        $base.addFilePathsToFormField();
    };

    Plugin.prototype.removeFromMyDownloads = function ($sender) {
        var $base = this;

        $sender.parents('li').remove();

        $base.addFilePathsToFormField();
    };

    Plugin.prototype.addFilePathsToFormField = function () {
        var $base = this;

        var $mydownloads = $($base.$element.data('mydownloadswrapper'));

        var filePaths = [];
        $('li', $mydownloads).each(function () {
            filePaths.push($(this).data('filepath'));
        });

        $('input[name="filePaths"]', $mydownloads).val(filePaths.join('|'));

        if (filePaths.length === 0) {
            $('button[type="submit"]', $mydownloads).addClass('hidden');
            $('p.no-files', $mydownloads).removeClass('hidden');
        } else {
            $('button[type="submit"]', $mydownloads).removeClass('hidden');
            $('p.no-files', $mydownloads).addClass('hidden');
        }
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);